module.exports = __webpack_public_path__ + "static/img/home-icon4.4caffaf0.png";